var React = require('react');

function BeforeYouStart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 1.248a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4zM6 3.25A2.75 2.75 0 0 0 3.25 6v14A2.75 2.75 0 0 0 6 22.75h12A2.75 2.75 0 0 0 20.75 20V6A2.75 2.75 0 0 0 18 3.25H6zM4.75 6c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v14c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25V6zm6.5 3.5a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75zM8 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm1.5 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm2.5-.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5z","fill":"#fff"}));
}

BeforeYouStart.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BeforeYouStart;

BeforeYouStart.default = BeforeYouStart;
